import { useTranslation } from 'react-i18next'

export function NoOfferingsAvailableMessage() {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-[#05155E] from-15% via-[#0163D0] to-[#4B97FE] p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="bg-gradient-to-tr from-[#05155E] from-15% via-[#0163D0] to-[#4B97FE] p-9">
            <p className="text-center text-white text-[40px] font-black tracking-[-4px]">DUPR</p>
          </div>

          <div className="p-8">
            <div className="flex flex-col items-center gap-y-4 text-center">
              <div className="flex items-center justify-center">
                <svg
                  className="w-16 h-16 text-[#0163D0]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-2.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 009.586 13H4"
                  />
                </svg>
              </div>

              <div className="text-center">
                <h2 className="text-xl font-semibold text-gray-900 mb-2">
                  {t('promotion.noOfferingsTitle', 'No current offerings')}
                </h2>
                <p className="text-gray-600">
                  {t(
                    'promotion.noOfferingsBody',
                    'Sorry, you’re not eligible for any current offerings. Check back in the future for more deals on merchandise, subscriptions, and other benefits!'
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NoOfferingsAvailableMessage
